import { Box, Grid, Typography, styled } from "@mui/material";
import React from "react";
import "react-image-gallery/styles/css/image-gallery.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { primary } from "../../../constants/theme";
import ProductImageSlider from "./ProductImageSlider";

// Show correct slider from first paint (no desktop→mobile flash). Match breakpoint to findViewport (480px).
const SliderWrapper = styled(Box)({
  ".gallery-desktop": {
    display: "block",
  },
  ".gallery-mobile": {
    display: "none",
  },
  "@media (max-width: 480px)": {
    ".gallery-desktop": {
      display: "none",
    },
    ".gallery-mobile": {
      display: "block",
    },
  },
});

const CustomProductImageSlider = styled(Box)(({ theme }) => ({
  ".productTypeSelector": {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: "10px",
  },
  ".productType": {
    display: "flex",
    justifyContent: "center",
    maxWidth: "160px",
    maxHeight: "50px",
    gap: "8px",
    //margin: "10px",
    alignItems: "center",
    padding: "4px",
    borderRadius: "6px",
    border: `2px solid ${primary.lightGrey}`,
    "&.active": {
      border: `2px solid ${primary.mainGreen}`,
      background: "#35BF681A",
    },
    ".productType-img": {
      objectFit: "contain",
      maxHeight: "60px",
      maxWidth: "60px",
    },
  },
  [theme.breakpoints.down("md")]: {
    ".productTypeSelector": {
      width: "100%",
      justifyContent: "flex-start",
      margin: "auto",
      marginTop: "10px",
      padding: " 0px 20px 0px 20px",
    },
    ".productType": {
      maxWidth: "120px",
      maxHeight: "56px",
      gap: "4px",
      margin: " 4px 0",

      ".productType-img": {
        maxHeight: "40px",
        maxWidth: "40px",
      },
      ".thumbnailTitle": {
        fontSize: "10px",
        fontWeight: "600",
      },
    },
  },
}));

const ImageGalleyV2 = ({
  vehicleData,
  productType,
  handleThumbnailClick,
  productList,
}) => {
  return (
    <Box>
      <SliderWrapper>
        <div className="gallery-desktop">
          <ProductImageSlider
            images={productType?.imagesDesktop}
            altText={vehicleData?.name}
          />
        </div>
        <div className="gallery-mobile">
          <ProductImageSlider
            images={productType?.imagesMobile}
            altText={vehicleData?.name}
          />
        </div>
      </SliderWrapper>
      {vehicleData?.type === "passenger" && (
        <CustomProductImageSlider>
          <Grid
            container
            className="productTypeSelector"
            style={{ display: vehicleData?.type === "passenger" ? "none" : "" }}
          >
            {productList?.map((item, index) => {
              return (
                <Grid
                  item
                  xs={4}
                  key={index}
                  className={
                    item?.type === productType?.type
                      ? "productType active"
                      : "productType"
                  }
                  onClick={() => {
                    handleThumbnailClick(item);
                  }}
                >
                  <LazyLoadImage
                  src={
                    item?.type === productType?.type
                      ? item?.thumbnailselected
                      : item?.thumbnailUnselected
                  }
                  className="productType-img"
                  loading="lazy"
                  alt="thumbnail selected"
                />
                  <Typography className="thumbnailTitle">
                    {item?.thumbnailTitle}
                  </Typography>
                </Grid>
              );
            })}
          </Grid>
        </CustomProductImageSlider>
      )}
    </Box>
  );
};
export default ImageGalleyV2;
